import { render, staticRenderFns } from "./FormCreateView.vue?vue&type=template&id=71d2dc6d&scoped=true"
import script from "./FormCreateView.vue?vue&type=script&lang=js"
export * from "./FormCreateView.vue?vue&type=script&lang=js"
import style0 from "./FormCreateView.vue?vue&type=style&index=0&id=71d2dc6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2dc6d",
  null
  
)

export default component.exports